import { Carousel, Container, Image } from 'react-bootstrap'
import { HomeRoadBlocksContainer } from './style'
import { useTranslation } from 'react-i18next'
import { FaAngleRight, FaAngleLeft } from 'react-icons/fa'
import { colors } from 'style'

function HomeRoadBlocks() {
  const { t } = useTranslation()
  const blocks = [
    {
      img: 'https://image.anecdobio.com/icon_hardcover.svg',
      title: t('home_block_title1'),
      description: t('home_block_description1'),
    },
    {
      img: 'https://image.anecdobio.com/icon_covers.svg',
      title: t('home_block_title2'),
      description: t('home_block_description2'),
    },
    {
      img: 'https://image.anecdobio.com/icon_design.svg',
      title: t('home_block_title3'),
      description: t('home_block_description3'),
    },
    {
      img: 'https://image.anecdobio.com/icon_family.svg',
      title: t('home_block_title4'),
      description: t('home_block_description4'),
    },
    {
      img: 'https://image.anecdobio.com/icon_writersblock.svg',
      title: t('home_block_title5'),
      description: t('home_block_description5'),
    },
    {
      img: 'https://image.anecdobio.com/icon_support.svg',
      title: t('home_block_title6'),
      description: t('home_block_description6'),
    },
  ]

  return (
    <HomeRoadBlocksContainer>
      <Container className="h-100">
        <div className="roadblocks-wrapper">
          <h2>{t('home_block_header')}</h2>
          {blocks.map((_block, _i) => (
            <div key={_i} className="roadblock-item">
              <div className="img-wrapper">
                <Image src={_block.img} />
              </div>
              <div className="roadblock-content">
                <h3>{_block.title}</h3>
                <h4>{_block.description}</h4>
              </div>
            </div>
          ))}
        </div>
        <div className="description-sm">
          <h3>
            We’ve removed the roadblocks so you can turn memories into a
            memoire.{' '}
          </h3>
        </div>
        <Carousel
          className="roadblocks-wrapper-sm"
          nextIcon={<FaAngleRight color={colors.blueDark} />}
          prevIcon={<FaAngleLeft color={colors.blueDark} />}
          fade
        >
          {blocks.map((_block, _i) => (
            <Carousel.Item key={_i}>
              <div className="roadblock-item">
                <div className="img-wrapper d-flex">
                  <Image src={_block.img} width={90} />
                  <h3 className="mt-3 ml-2">{_block.title}</h3>
                </div>
                <div className="roadblock-content mt-3">
                  <h4>{_block.description}</h4>
                </div>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </Container>
    </HomeRoadBlocksContainer>
  )
}

export default HomeRoadBlocks
